import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-800 text-center" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <p className="text-slate-400 font-medium mb-4" data-id="element-63">
          KinesioTapingPro © {new Date().getFullYear()}. Todos los derechos
          reservados.
        </p>
        <p className="text-slate-600 text-sm max-w-2xl mx-auto" data-id="element-64">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}